<template>
  <div class="container-fluid im-fluid" @click="handleHideMenu">
    <h2 class="im-title im-title-resources">{{ $t("resources.title") }}</h2>

    <div v-if="displayPageContent" class="row im-filter sticky-top">
      <div class="col col-12 col-sm-12 pt-2">
        <h5 class="mb-1">{{ $t("resources.filter") }}</h5>
        <v-select
          ref="tagsList"
          v-model="selectedTags"
          multiple
          :options="availableTags"
        ></v-select>
      </div>
    </div>

    <div v-if="displayPageContent" class="row mt-2">
      <div class="col-12">
        <h5 class="mb-4">{{ $t("resources.results", { count: amountOfResourcesFound }) }}</h5>

        <div v-for="item in resourcesToDisplay" :key="item.id" class="resource">
          <a v-bind="{ href: item.link }" target="_blank">{{ item.link }}</a
          ><br />
          <p>{{ item.description }}</p>
          <div>
            <small>{{ $t("resources.tags") }}: </small>
            <span v-for="(tag, index) in item.tags" :key="index" class="badge bg-info">{{
              tag
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vSelect from "vue-select";

  export default {
    name: "SelfLearningResourcesSection",
    components: {
      "v-select": vSelect,
    },
    data() {
      return {
        currentPage: 1,
        maxItemsPerPage: 10,
        resourcesFound: [],
        amountOfResourcesFound: 0,

        selectedTags: [],
        availableTags: [],

        displayPageContent: false,
        content: {
          tags: [],
          resources: [],
          resource_tag: [],
        },
      };
    },
    computed: {
      resourcesToDisplay() {
        var items = [];

        for (var i = 0; i < this.maxItemsPerPage * this.currentPage; i++) {
          if (typeof this.resourcesFound[i] !== "undefined") {
            items.push(this.resourcesFound[i]);
          } else {
            break;
          }
        }

        return items;
      },
    },
    watch: {
      selectedTags: function () {
        for (var tag in this.availableTags) {
          this.availableTags[tag].label =
            this.availableTags[tag].tagName +
            " (" +
            this.availableTags[tag].totalTagResources +
            ")";
        }
        for (var tag in this.selectedTags) {
          this.selectedTags[tag].label = this.selectedTags[tag].tagName;
        }
        this.tagToggled();
      },
    },
    created() {
      window.scrollTo(0, 0);
      this.loadContent();
    },
    unmounted() {
      window.onscroll = null;
    },
    methods: {
      handleHideMenu() {
        if (this.hideMenu) {
          this.hideMenu();
        }
      },
      getTagDataFromId(tag_id) {
        for (var i in this.content.tags) {
          if (this.content.tags[i].id == tag_id) {
            return this.content.tags[i];
          }
        }
      },
      getTagNamesFromResourceId(resource_id) {
        var tags = [];

        var tag;
        for (var i in this.content.resource_tag) {
          if (this.content.resource_tag[i].resource_id == resource_id) {
            tag = this.getTagDataFromId(this.content.resource_tag[i].tag_id);
            tags.push(tag.name);
          }
        }

        return tags;
      },
      getResourceData(resource_id) {
        for (var i in this.content.resources) {
          if (this.content.resources[i].id == resource_id) {
            return {
              id: this.content.resources[i].id,
              link: this.content.resources[i].link,
              description: this.content.resources[i].description,
              created_at: this.content.resources[i].created_at,
            };
          }
        }
      },
      setupResourcesFound(selected_tag_ids) {
        var resourcesFound = [];

        var resource = [];
        var added = false;
        for (var i in selected_tag_ids) {
          for (var a in this.content.resource_tag) {
            if (this.content.resource_tag[a].tag_id == selected_tag_ids[i]) {
              // avoid adding an item that has already been added
              added = false;
              for (var r in resourcesFound) {
                if (resourcesFound[r].id == this.content.resource_tag[a].resource_id) {
                  added = true;
                  break;
                }
              }
              if (added) {
                continue;
              }

              resource = this.getResourceData(this.content.resource_tag[a].resource_id);
              resource.tags = this.getTagNamesFromResourceId(
                this.content.resource_tag[a].resource_id
              );

              // add the current resource to the list with resources that the user will see
              resourcesFound.push(resource);
            }
          }
        }

        resourcesFound
          .sort(function (a, b) {
            var aTime = new Date(a.created_at).getTime();
            var bTime = new Date(b.created_at).getTime();
            if (aTime === bTime) {
              return 0;
            } else {
              return aTime < bTime ? -1 : 1;
            }
          })
          .reverse();

        this.resourcesFound = resourcesFound;

        this.amountOfResourcesFound = resourcesFound.length;
      },
      updateUrlSelectedTagIds(selected_tag_ids) {
        var current_ids = null;
        if (typeof this.$route.params.ids === "string") {
          current_ids = this.$route.params.ids;
        }

        if (selected_tag_ids.length == 0) {
          if (current_ids !== null) {
            this.$root.gotoSelfLearningResources();
          }
        } else {
          var selected_ids = selected_tag_ids.join(":");
          if (current_ids !== selected_ids) {
            this.$root.gotoSelfLearningResourcesWithSelectedIds(selected_ids);
          }
        }
      },
      tagToggled() {
        var selected_tag_ids;
        selected_tag_ids = this.getAllSelectedTagIds();

        this.updateUrlSelectedTagIds(selected_tag_ids);

        if (selected_tag_ids.length == 0) {
          this.setupResourcesNoTagSelected();
        } else {
          this.setupResourcesFound(selected_tag_ids);
        }
      },
      getAllSelectedTagIds() {
        var selected_tag_ids = [];

        for (var tag in this.selectedTags) {
          selected_tag_ids.push(parseInt(this.selectedTags[tag].value));
        }

        return selected_tag_ids;
      },
      getTotalResourcesForTag(tagId) {
        var total = 0;

        for (var i in this.content.resource_tag) {
          if (this.content.resource_tag[i].tag_id == tagId) {
            total++;
          }
        }

        return total;
      },
      setupScrollPositionCapture() {
        // if the window scroll hit the bottom of the page then load more items, if any left

        var onScroll = function (ev) {
          // add more resources to the bottom of the list
          if (
            window.innerHeight + window.scrollY >= document.body.offsetHeight &&
            this.amountOfResourcesFound > 0 &&
            this.currentPage * this.maxItemsPerPage < this.amountOfResourcesFound
          ) {
            this.currentPage++;
          }
        };

        window.onscroll = onScroll.bind(this);
      },
      setupResourcesNoTagSelected() {
        var selected_tag_ids = [];
        for (var i in this.content.tags) {
          selected_tag_ids.push(this.content.tags[i].id);
        }

        this.setupResourcesFound(selected_tag_ids);
      },
      setupAvailableTags() {
        var availableTags = [];
        var totalTagResources = 0;

        for (var tag in this.content.tags) {
          totalTagResources = this.getTotalResourcesForTag(this.content.tags[tag].id);

          availableTags.push({
            totalTagResources: totalTagResources,
            tagName: this.content.tags[tag].name.toString(),
            value: this.content.tags[tag].id.toString(),
            label: this.content.tags[tag].name.toString() + " (" + totalTagResources + ")",
          });
        }

        this.availableTags = availableTags;
      },
      resetSelectedTags() {
        this.selectedTags = [];
      },
      normalizePreselectedTags() {
        var params = this.$route.params;

        if (typeof params.ids !== "string") {
          if (this.selectedTags.length > 0) {
            this.resetSelectedTags();
          }
        } else {
          this.setupPreselectedTags(params.ids);
        }
      },
      setupPreselectedTags(param_ids) {
        var res = /^(?!0)\d+((:(?!0)\d+)+)?$/.exec(param_ids);
        if (res === null) {
          this.$root.gotoError404();
          return;
        }

        var tagIds = res[0].split(":");
        var selectedTags = [];

        for (var t in tagIds) {
          for (var i in this.availableTags) {
            if (tagIds[t] == this.availableTags[i].value) {
              selectedTags.push({
                totalTagResources: this.availableTags[i].totalTagResources,
                tagName: this.availableTags[i].tagName,
                label: this.availableTags[i].label,
                value: this.availableTags[i].value,
              });
              break;
            }
          }
        }

        this.selectedTags = selectedTags;
      },
      initialSetupPreselectedTags() {
        var params = this.$route.params;
        if (typeof params.ids !== "string") {
          return;
        }

        this.setupPreselectedTags(params.ids);
      },
      initPage() {
        this.setupAvailableTags();
        this.setupScrollPositionCapture();
        this.setupResourcesNoTagSelected();
        this.initialSetupPreselectedTags();
        this.displayPageContent = true; // we can display the content now
      },
      loadContent() {
        this.$request
          .get("/resources/loadcontent")
          .catch(this.$root.responseErrorHandler)
          .then(this.$root.responseMiddleware)
          .then((response) => {
            // console.dir(response);

            if (response && response.success) {
              this.content.tags = response.success.tags;
              this.content.resources = response.success.resources;
              this.content.resource_tag = response.success.resource_tag;
            } else {
              console.error("Invalid API response structure:", response);
              // Set empty data to prevent crashes
              this.content.tags = [];
              this.content.resources = [];
              this.content.resource_tag = [];
            }

            this.initPage();
          });
      },
    },
  };
</script>
